var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7488 16.043L14.7547 33.2841C14.5809 33.5062 14.3325 33.6578 14.0556 33.7108C13.7787 33.7639 13.4919 33.7149 13.2483 33.5729C13.0048 33.4309 12.8209 33.2054 12.7307 32.9383C12.6405 32.6712 12.6501 32.3804 12.7577 32.1198L17.1004 22.1126L17.061 22.0563L9.29258 22.8157C9.08716 22.8365 8.87991 22.8022 8.69214 22.7163C8.50438 22.6304 8.34289 22.4961 8.2243 22.3271C8.1057 22.1581 8.03428 21.9605 8.01739 21.7547C8.00049 21.5489 8.03873 21.3424 8.12817 21.1563L16.7685 2.91375C16.8624 2.7156 17.0105 2.54811 17.1957 2.43064C17.3808 2.31318 17.5955 2.25055 17.8147 2.25H17.8822L22.2587 2.48625C22.4501 2.49549 22.6362 2.55226 22.8002 2.65145C22.9642 2.75064 23.1009 2.88912 23.198 3.05437C23.2945 3.21847 23.3495 3.40361 23.3583 3.59376C23.3672 3.78391 23.3295 3.97334 23.2486 4.14566L18.1016 14.9629L18.141 15.0192L26.7082 14.181C26.9335 14.1598 27.1602 14.2042 27.3609 14.309C27.5615 14.4139 27.7275 14.5745 27.8388 14.7717C27.9506 14.9689 28.0018 15.1947 27.9857 15.4209C27.9697 15.647 27.8873 15.8634 27.7488 16.043Z",
    fill: "url(#paint0_linear_1563_733)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_733",
    x1: 8.0117,
    y1: 18,
    x2: 27.9883,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.9420a4a8ea24be57f78156abad07fe52.svg";
export { ForwardRef as ReactComponent };